/* eslint-disable */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Import separated components
import Header from "./common/Header";
import HeroSection from "./sections/HeroSection";
import ProductsSection from "./sections/ProductsSection";
import AdvantagesSection from "./sections/AdvantagesSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import ContactSection from "./sections/ContactSection";
import Footer from "./common/Footer";

/**
 * TextileSlingLanding component serves as the main layout for the landing page,
 * orchestrating various sections.
 * It also handles smooth scrolling to sections based on the URL hash.
 * @return {React.ReactElement} The TextileSlingLanding component.
 */
const TextileSlingLanding = () => {
  const location = useLocation();

  useEffect(() => {
    // This effect handles smooth scrolling when a URL hash is present.
    const timeoutId = setTimeout(() => {
      if (location.hash) {
        const id = location.hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          const headerOffset = 80; // Must match the offset used in Header.js
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [location]);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection id="главная" />
      <ProductsSection id="продукция" />
      <AdvantagesSection id="преимущества" />
      <TestimonialsSection />
      <ContactSection id="контакты" />
      <Footer />
    </div>
  );
};

export default TextileSlingLanding;
